//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CarNoInput from "@/components/carNo-input";
import Model from "@/models/mobile";
export default {
  components: {
    CarNoInput
  },
  data() {
    return {
      carType: "plate",
      formData: {
        carNo: "",
        unParkNo: "",
        freeDuration: "",
        busNo: ""
      },
      checkPass: false,
      checkMsg: "",
      rules: {}
    };
  },
  methods: {
    async getDetail() {
      const { carNo, busNo, unParkNo } = this.formData;
      const { parkNum, isCard, parkType, rulesNum } = this.$route.params;
      if (this.carType == "plate" && carNo.length < 7) {
        this.$layer.msg("请输入正确的车牌号码");
        return;
      }
      let { data } = await Model.getQrcodeFindScan({
        parkNo: parkNum,
        isOpen: isCard,
        carType: parkType,
        ruleId: rulesNum,
        carNo: carNo
      });
      // 257369 ||  判断 临时处理
      if (parkNum == 257369) {
        this.$layer.msg("该二维码已停止使用");
      } else {
        if (data.success) {
          localStorage.setItem("day", carNo);
          //1是开卡，2是续费
          const { type } = data.list;

          sessionStorage.setItem("scanCodeataList", JSON.stringify(data.list));

          if (type == 1) {
            this.$router.push({
              path: "/mobile/openCardDetails",
              query: data.list
            });
          } else {
            this.$router.push({
              path: "/mobile/renewalDetails",
              query: data.list
            });
          }
        }

        data.success ? this.$layer.msg(data.msg) : this.$layer.msg(data.error);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/openRenew_Card.vue